import React from 'react';

import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { getNextMemberCredit } from '../../utils/selectors';
import { Component as Price } from '../ExtendedPrice';
import { withShoppingBagRevampUX } from '../MemberCreditsCartToggle/WithShoppingBagRevampUX';

const StyledContainer = styled.div`
  margin-top: 8px;
  margin-left: 12px;
  margin-right: 12px;
  height: 24px;
  border-color: ${props => props.theme.colors.lavender200};
  border-width: 1px;
  border-style: solid;
  display: flex;
  flex-direction: row;
  justify-content: ${props =>
    props.percentage === 0 ? 'end' : 'space-between'};
  align-items: center;
  ${({ isShoppingBagRevampUX }) =>
    isShoppingBagRevampUX &&
    `
    margin: 0;
  `}
`;
const Container = withShoppingBagRevampUX(StyledContainer);
const Progress = styled.div`
  background-color: ${props => props.theme.colors.lavender200};
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: end;
  align-items: center;
  padding-right: 8px;
`;

const MembershipPrice = styled.div`
  color: ${props => props.theme.colors.lavender300};
  font-weight: 700;
  font-size: 12px;
  margin-right: 8px;
`;

const LOGO_THRESHOLD = 10;
const PRICE_THRESHOLD = 85;

export const ProgressBarNMP = () => {
  const membershipPrice = useSelector(state => state.membership.price);

  const nextMemberShipPrice = useSelector(getNextMemberCredit);

  const cart = useSelector(state => state.checkout);

  const percentage = (cart.total / membershipPrice).toFixed(2) * 100;

  return (
    <Container percentage={percentage}>
      {percentage === 0 ? null : (
        <Progress
          style={{
            width: `${percentage}%`,
          }}
        >
          {percentage > LOGO_THRESHOLD ? (
            <img
              alt="Wheel"
              src="/static/images/wheel-logo.svg"
              width="16"
              height="16"
            />
          ) : null}
        </Progress>
      )}
      {percentage < PRICE_THRESHOLD ? (
        <MembershipPrice>
          <Price amount={nextMemberShipPrice} />
        </MembershipPrice>
      ) : null}
    </Container>
  );
};
